var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShellfish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7868 2.3142C10.8468 2.5622 10.8628 2.8254 10.826 3.095L10.1684 7.9302M10.7868 2.3142C10.2812 0.2286 7.2188 0.2286 6.7132 2.3142M10.7868 2.3142C12.0404 1.0278 14.2908 2.3086 14.35 3.9174M6.7132 2.3142C6.6532 2.5622 6.638 2.8254 6.674 3.095L7.3316 7.9302M6.7132 2.3142C5.4596 1.0278 3.2092 2.3086 3.15 3.9182C3.0956 5.3902 4.102 7.3662 4.9916 8.7334M14.35 3.9174C15.15 4.0518 16.75 4.8014 16.75 6.727C16.75 8.4654 14.6644 10.3022 12.6036 11.7622C12.138 12.0918 11.9052 12.2566 11.7556 12.3766C11.3369 12.7031 10.9654 13.0859 10.6516 13.5142C10.5364 13.6662 10.4172 13.8462 10.1788 14.2046L9.9932 14.4846C9.85697 14.6895 9.67218 14.8576 9.45528 14.9739C9.23838 15.0902 8.9961 15.151 8.75 15.151C8.5039 15.151 8.26162 15.0902 8.04472 14.9739C7.82782 14.8576 7.64303 14.6895 7.5068 14.4846L7.3212 14.2046C7.17023 13.9702 7.01284 13.74 6.8492 13.5142C6.5349 13.0858 6.16284 12.703 5.7436 12.3766C5.5948 12.2566 5.362 12.0918 4.8964 11.7622C2.8356 10.3022 0.75 8.4662 0.75 6.7262C0.75 4.8006 2.35 4.051 3.15 3.9166M14.35 3.9174C14.4044 5.3894 13.398 7.3646 12.5084 8.7318",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5502 11.1502L12.943 14.1854C12.8886 14.4573 12.7418 14.702 12.5274 14.8779C12.313 15.0538 12.0443 15.15 11.767 15.1502H5.73419C5.45675 15.1502 5.18786 15.0541 4.97331 14.8782C4.75875 14.7023 4.61178 14.4575 4.5574 14.1854L3.9502 11.1502",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShellfish);
export default __webpack_public_path__ + "static/media/shellfish.5f74a12f1fa36acadba342c5c07bcfb5.svg";
export { ForwardRef as ReactComponent };